import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getMeQueryOptions } from '../../auth/services/useMeQuery'
import { intentionApi } from '../api/intentionApi'
import type { TCreateIntentionPayload } from '../api/types/createIntentionApi.types'

export const useCreateIntentionMutation = (payload: Omit<TCreateIntentionPayload, 'content'> = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (content: string) => intentionApi.createIntention({ ...payload, content }),
    onSuccess: (intention) => {
      queryClient.setQueryData(getMeQueryOptions().queryKey, (data) => data && { ...data, intention })
    },
  })
}
